










































































































































































































































































































import { Component, Vue } from 'vue-property-decorator'
import { Deal, DealMedia, Venue } from '@/types/Deal'
import dealModule from '@/store/deal'
import { DiscountType, DealType } from '@/utils/enums'
import FMap from '@/components/common/FMap.vue'
import DealRedeemDialog from '@/components/deal/DealRedeemDialog.vue'
import { Marked, Renderer } from '@ts-stack/markdown'

Marked.setOptions({
  renderer: new Renderer()
})

Marked.options.renderer!.link = (href, title, text) => {
  return `<a target="_blank" href="${href}" title="${title}">${text}</a>`
}

@Component({
  components: {
    DealRedeemDialog
  }
})
export default class DealDetail extends Vue {
  private discounttype = DiscountType
  private loading = true
  private limit = 3
  private showAllVenues = false
  private currentVenue = 0
  private couponPrice = 0
  private retailPrice = 0

  private get sortedVenues(): Venue[] {
    const activeVenue = this.deal.venues[this.currentVenue]
    const inactiveVenues = this.deal.venues.filter(
      el => el._id !== activeVenue._id
    )
    inactiveVenues.unshift(activeVenue)
    return inactiveVenues
  }

  private get showMoreVenues(): Venue[] {
    return this.limit > 0
      ? this.sortedVenues.slice(1, this.limit + 1)
      : this.sortedVenues.slice(1)
  }

  private get showVenueBtn(): boolean {
    if (this.deal.venues.length > this.limit) {
      return true
    } else {
      return false
    }
  }

  private get showVenueBtnText(): string {
    if (this.deal.venues.length > 3 && !this.showAllVenues) {
      return 'Alle anzeigen'
    } else {
      return 'Weniger anzeigen'
    }
  }

  private updateVenue(venue: Venue): void {
    const index = this.deal.venues.indexOf(venue)
    this.currentVenue = index
    const fmap = this.$refs['detail-map-container'] as FMap
    fmap.panToVenue(index)
  }

  private get storeModule() {
    return dealModule
  }

  private get deal(): Deal {
    return dealModule.deal
  }

  private get instagramURL(): string {
    if (this.deal.type === DealType.LOCAL) {
      return (
        this.deal.venues[this.currentVenue].instagram ||
        this.deal.company.instagram
      )
    }
    return this.deal.company.instagram
  }

  private get facebookURL(): string {
    if (this.deal.type === DealType.LOCAL) {
      return (
        this.deal.venues[this.currentVenue].facebook ||
        this.deal.company.facebook
      )
    }
    return this.deal.company.facebook
  }

  private get websiteURL(): string {
    if (this.deal.type === DealType.LOCAL) {
      return this.deal.venues[this.currentVenue].url || this.deal.company.url
    }
    return this.deal.company.url
  }

  private get phoneNumber(): string {
    if (this.deal.type === DealType.LOCAL) {
      return (
        this.deal.venues[this.currentVenue].phone || this.deal.company.phone
      )
    }
    return this.deal.company.phone
  }

  private get emailAddress(): string {
    if (this.deal.type === DealType.LOCAL) {
      return (
        this.deal.venues[this.currentVenue].email || this.deal.company.email
      )
    }
    return this.deal.company.email
  }

  private get emailPublic(): boolean {
    if (
      this.deal.type === DealType.LOCAL &&
      this.deal.venues[this.currentVenue].emailPublic !== undefined
    ) {
      return this.deal.venues[this.currentVenue].emailPublic!
    }
    return this.deal.company.emailPublic
  }

  private get whatsappNumber(): string | undefined {
    let whatsappNumber = this.deal.company.whatsapp
    if (this.deal.type === DealType.LOCAL) {
      whatsappNumber =
        this.deal.venues[this.currentVenue].whatsapp ||
        this.deal.company.whatsapp
    }

    if (!whatsappNumber || whatsappNumber.length === 0) return undefined

    if (whatsappNumber[0] === '0') {
      // mit Landesvorwahl
      whatsappNumber = `49${whatsappNumber.substr(1)}`
    } else {
      // ohne Landesvorwahl
      whatsappNumber = `${whatsappNumber.substr(1)}`
    }
    whatsappNumber.replace(/[^0-9]/g, '')

    return whatsappNumber
  }

  private get media(): DealMedia[] {
    return this.deal.media
  }

  private get venueLocations() {
    return dealModule.deal.venues.map(el => {
      return { location: el.address.location, dealId: dealModule.deal._id }
    })
  }

  private get containerClass(): string {
    return this.$vuetify.breakpoint.mdAndDown
      ? 'mx-auto'
      : 'content-container mx-auto'
  }

  private get showMap(): boolean {
    if (this.deal.type !== DealType.LOCAL || this.loading) {
      return false
    }
    return true
  }

  private navBack(): void {
    this.$router.back()
  }

  private get formattedCouponPrice() {
    return this.couponPrice.toFixed(2)
  }

  private get formattedRetailPrice() {
    return this.retailPrice.toFixed(2)
  }

  private get formattedOldPrice() {
    return this.deal.discount.oldPrice.toFixed(2)
  }

  private get formattedNewPrice() {
    return this.deal.discount.newPrice.toFixed(2)
  }

  private get formattedRelief() {
    return this.deal.discount.relief.toFixed(2)
  }

  private get isBookmark(): boolean {
    if (!dealModule.bookmarks) {
      return false
    }
    return dealModule.bookmarks.map(el => el.deal._id).includes(this.deal._id)
  }

  private get publicTransportUrl() {
    const address = this.sortedVenues[0]?.address
    if (!address) return null
    return `https://www.westfalenfahrplan.de/std3/XSLT_TRIP_REQUEST2?std3_suggestMacro=std3_suggest&std3_commonMacro=trip&std3_contractorMacro=&useRealtime=1&name_destination=${encodeURIComponent(
      `${address.street} ${address.streetNo}, ${address.zipCode} ${address.city}`
    )}&type_destination=any&itdLPxx_directRequest=1&coordOutputFormat=WGS84`
  }

  private parseMd(md: string) {
    return Marked.parse(md)
  }

  private async created() {
    document.title = `Münsterland.de - Deal laden …`
    await dealModule.fetch(this.$route.params.id)
    this.loading = false
    document.title = `Münsterland.de - ${this.deal.name}`
    if (!dealModule.bookmarks) {
      await dealModule.fetchBookmarks()
    }
    this.couponPrice = await dealModule.getActiveCouponPrice(this.deal)
    this.retailPrice = await dealModule.getActiveRetailPrice(this.deal)
  }

  private async handleBookmark(): Promise<void> {
    if (this.isBookmark) {
      await dealModule.deleteBookmark(this.deal)
    } else {
      await dealModule.createBookmark(this.deal)
    }
    dealModule.fetchBookmarks()
  }

  private toggleVenues(): void {
    this.limit = this.showAllVenues ? 3 : 0
    this.showAllVenues = !this.showAllVenues
  }
}
